import { AccessLevel, PlanSettings } from "@authory-packages/core";

export const canUseProFeature = (planSettings: PlanSettings) => {
    return planSettings.accessLevel === AccessLevel.Pro;
};
